import { useParams } from 'react-router-dom';
import { useExercisePageRedirect } from '@pages/programs/exercise/helpers.ts';
import { ExerciseMenu } from '@widgets/exercises';
import { ArrowShortLeft } from '@shared/assets';
import { useMobile } from '@shared/hooks';
import { useModuleByCodeParam } from '@shared/hooks/use-module-by-code-param.ts';
import { useScrollToTop } from '@shared/hooks/useScrollToTop';
import type { ExerciseVideo } from '@shared/types/exercises';
import { IconButton, ListBody, PageHead, PageTitle, Player } from '@shared/ui';
import DescriptionViewer from '@shared/ui/viewer-note-editor-content/description-viewer/index.tsx';
import { useExerciseQuery } from '@src/api/api-hooks/exercises/useExerciseQuery.ts';
import Loader from '@src/library/components/common/Loader/index.ts';
import * as st from './styles.module.scss';

type PT = {
  isTempExercise?: boolean;
};
export const Exercise = ({ isTempExercise }: PT) => {
  const { code } = useModuleByCodeParam();
  const { doRedirectOnPrevPage } = useExercisePageRedirect();
  const { videoId } = useParams<{ code: string; videoId: string; id: string }>();
  const exerciseId = Number(videoId);

  useScrollToTop();

  const { data: exercise, isLoading } = useExerciseQuery({ id: videoId });

  const onClose = () => doRedirectOnPrevPage(`/programs/${code}/exercises`);

  const { isMobile } = useMobile();

  const renderDesktopContent = () => (
    <div className={st.video}>
      <h2 className={st.title}>{exercise?.title}</h2>
      {exercise?.description && <DescriptionViewer description={exercise.description} />}
      <div className={st.videoWrapper}>
        <Player video={exercise as ExerciseVideo} />
      </div>
    </div>
  );

  if (isLoading) {
    return <Loader />;
  }

  const renderMobileContent = () => {
    if (!exercise) {
      return null;
    }

    return (
      <div className={st.video}>
        <div className={st.block}>{<Player video={exercise} />}</div>
        <div className={st.content}>
          {exercise.title && <div className={st.content__title}>{exercise.title}</div>}

          {
            exercise.description && (
              <DescriptionViewer description={exercise.description} isAlwaysFull />
            )
            // <div className={st.content__body}>{exercise.description}</div>
          }
        </div>
      </div>
    );
  };

  return (
    <>
      <PageTitle title={'Видео'} />
      <PageHead
        Left={
          <div className={st.button}>
            <IconButton variant="dark" onClick={onClose}>
              <ArrowShortLeft />
            </IconButton>
          </div>
        }
        Right={<ExerciseMenu videoId={exerciseId} isTempExercise={isTempExercise} />}
      />
      <ListBody>{!isMobile ? renderDesktopContent() : renderMobileContent()}</ListBody>
    </>
  );
};
